import { ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
})
export class FormErrorComponent {
  @Input() set text(value: string) {
    this.toggleText(value);
  }
  @Input() set enabled(value: boolean) {
    this._enabled = value;
  }
  // @HostBinding('style.marginTop') marginTop = '0';
  // @HostBinding('style.marginBottom') marginBottom = '0';
  _text: string;
  _hide = true;
  _enabled = true;

  constructor(private cdr: ChangeDetectorRef) {}

  toggleText(value: string) {
    if (value !== this._text) {
      this._text = value;
      this._hide = !value;
    }
    // if (this._hide || !this._text) {
    //   this.marginTop = '0';
    //   // this.marginBottom = '0';
    // } else {
    //   this.marginTop = '10px';
    //   // this.marginBottom = '10px';
    // }
    this.cdr.detectChanges();
  }
}
